import CandidateProfile from './CandidateProfile.page';

export default CandidateProfile;
